import React, { useContext } from 'react';
import { DataContext } from 'entries/common/widgets/context';
import { useRobotintScript } from 'pages/calculation/hooks/use-robotint-script.hook';
import { useTintColor } from 'pages/calculation/hooks/use-tint-color.hook';
import { useTintServiceState } from 'pages/calculation/store/tint-service';
import { useRobotintConfig } from 'pages/calculation/hooks/use-robotint-config.hook';
import { selectTintColorContainer } from './styles';
import { ChooseColorButton } from './ChooseColorButton';
import './tint.css';

export const SelectTintColor = () => {
  const data = useContext(DataContext);
  const {
    selectedColor,
    setSelectedTintColor,
    deleteColorFromSelected,
    isTintServiceAvailable,
    setIsTintServiceAvailable,
  } = useTintServiceState();
  const robotintConfig = useRobotintConfig();

  const dataForIntegration = JSON.stringify({
    BARCODE: data?.barcode,
  });
  const isAnyColorsSelected = selectedColor !== null;

  const { handleSelectColor, openChooseColorModal } = useTintColor({
    setSelectedTintColor,
    deleteColorFromSelected,
    isTintServiceAvailable,
    setIsTintServiceAvailable,
  });

  useRobotintScript({
    robotintConfig,
    handleSelectColor,
    productId: data?.productId,
  });

  if (robotintConfig.robotintLink.length === 0) {
    return null;
  }

  return (
    <div data-testid="select-tint-color-container" className={selectTintColorContainer}>
      {!isAnyColorsSelected && (
        <ChooseColorButton
          isTintAvailable={isTintServiceAvailable}
          openChooseColorModal={openChooseColorModal}
          dataForIntegration={dataForIntegration}
        />
      )}
    </div>
  );
};
